import React, { useCallback, useEffect, useState } from "react";
import Breadcumbs from "../../../../../component/page-components/breadcumbs/breadcumbs";
import { TitlePage } from "../../../../../component/page-components";
import { AutoComplete, Input, Skeleton, Tooltip } from "antd";
import ButtonAddWithIcon from "../../../../../component/button/ButtonAddWithIcon";
import DropdownSearchDepot from "../../../../../component/dropdown-search/dds-depot";
import * as CrudServices from "../../../../../service/crudServices";
import style from "../DeliveryAssociate.module.css";
import { useSelector } from "react-redux";
import CustomTable from "../../../../../component/table/CustomTable";
import {
  DAActiveIcon,
  DANonActiveIcon,
  DeleteIcon,
  DetailIcon,
  EditIcon,
  InvitationExpiredIcon,
  InvitationOpenedIcon,
  InvitationSentIcon,
  OutsourceIcon,
  OwnedIcon,
  ProfileKosong,
} from "../../../../../asset";
import { t } from "i18next";
import changeResponseToArrayMap from "../../../../../helpers/changeResponseToArrayMap";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../../constant/routeConstant";
import * as DeliveryAssociateServices from "../../../../../service/master/DeliveryAssociateServices";
import DeleteConfirmationModal from "../../../../../component/modal/DeleteConfirmationModal";
import SuccessModal from "../../../../../component/modal/SuccessModal";
import ModalFailedDelete from "../../../../../component/modal/ModalFailedDelete";

const DeliveryAssociateList = () => {
  const { token } = useSelector((state) => state.auth);

  const navigate = useNavigate();
  const location = useLocation();

  const [depot, setDepot] = useState();
  const [listDeliveryAssociate, setListDeliveryAssociate] = useState([]);
  const [initiateDeliveryAssociate, setInitiateDeliveryAssociate] = useState(
    {}
  );
  const [failedModalOpen, setFailedModalOpen] = useState(false)
  const [failedMessage, setFailedMessage] = useState("")
  const [params, setParams] = useState({ page: 1, limit: 10 });
  const [searchRecommendation, setSearchRecommendation] = useState([]);
  const [deleteConfirmationModalOpen, setDeleteConfirmationModalOpen] =
    useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState();
  const [selectedUpdatedAt, setSelectedUpdatedAt] = useState();
  const [selectedVehicleType, setSelectedVehicleType] = useState();
  const [selectedDriverName, setSelectedDriverName] = useState();
  const [isSkeleton, setIsSkeleton] = useState(true);

  const _toAdd = useCallback(() => {
    navigate(ROUTES.DELIVERY_ASSOCIATE.ADD, { state: { id: depot } });
  }, [depot, navigate]);

  const getListDeliveryAssociate = useCallback(
    async (depotID, search) => {
      const newParams = search
        ? {
            ...params,
            filter: `depot_id eq ${depotID}, full_name lk ${search}`,
          }
        : { ...params, filter: `depot_id eq ${depotID}` };

      const resInitiate = await CrudServices.getInitiate(
        token,
        `delivery-associate/initiate`,
        newParams
      );

      const { data, ok } = await CrudServices.getList(
        token,
        `delivery-associate`,
        newParams
      );
      if (ok && data !== null) {
        setInitiateDeliveryAssociate(resInitiate?.initiate);
        setListDeliveryAssociate(data);
        setIsSkeleton(false);
        return;
      }
      setInitiateDeliveryAssociate(resInitiate?.initiate);
      setListDeliveryAssociate([]);
      setIsSkeleton(false);
    },
    [params, token]
  );

  useEffect(() => {
    setIsSkeleton(true);
    if (!depot) {
      setIsSkeleton(false);
      return;
    }
    getListDeliveryAssociate(depot);
  }, [depot, getListDeliveryAssociate]);

  const handleChangeLimit = useCallback(
    (page, size) => {
      const newParams = { ...params, page, limit: size };
      setParams(newParams);
    },
    [params]
  );

  const getSearchRecommendation = useCallback(
    async (search) => {
      const newParams = {
        ...params,
        filter: `depot_id eq ${depot}, full_name lk ${search}`,
      };

      const { ok, data } = await CrudServices.getList(
        token,
        `delivery-associate/search`,
        newParams
      );

      if (ok && data !== null) {
        setSearchRecommendation([
          ...changeResponseToArrayMap(data, "value", "value"),
        ]);
        return;
      }
      setSearchRecommendation([]);
    },
    [depot, params, token]
  );

  const onChangeSearch = useCallback(
    (evt) => {
      if (!evt) {
        const newParams = { ...params };
        delete newParams.filter;
        setParams(newParams);
        setSearchRecommendation([]);
        return;
      }
      getSearchRecommendation(evt);
    },
    [getSearchRecommendation, params]
  );

  const onSelectedData = useCallback(
    (keyword) => {
      if (!keyword) {
        return;
      }
      getListDeliveryAssociate(depot, keyword);
    },
    [depot, getListDeliveryAssociate]
  );

  const _toEdit = useCallback(
    (id) => {
      navigate(ROUTES.DELIVERY_ASSOCIATE.EDIT, {
        state: {
          id,
          prevPage: location?.pathname,
        },
      });
    },
    [location?.pathname, navigate]
  );

  const _actionDelete = useCallback(
    (id, updated_at, vehicleType, driverName) => {
      setSelectedId(id);
      setSelectedUpdatedAt(updated_at);
      setSelectedVehicleType(vehicleType);
      setSelectedDriverName(driverName);
      setDeleteConfirmationModalOpen(true);
    },
    []
  );

  const doDeleteDA = useCallback(
    async (id, updatedAt) => {
      let body = {
        updated_at: updatedAt,
      };

      try {
        const res = await DeliveryAssociateServices.deleteDeliveryAssociate(
          token,
          id,
          body
        );
        if (res.ok) {
          const newParams = {
            page: 1,
            limit: 10,
            filter: `depot_id eq ${depot}`,
          };

          setSuccessModalOpen(true);
          setSelectedId();
          setSelectedDriverName();
          setSelectedVehicleType();
          setSelectedUpdatedAt();
          setDeleteConfirmationModalOpen(false);
          setParams(newParams);
        }else{
          
        setDeleteConfirmationModalOpen(false);
        setFailedModalOpen(true)
        setFailedMessage(res.message);
        console.log("res", res);
        }
      } catch (error) {
        // setFailedModalOpen(true)
        console.log(error);
      }
    },
    [depot, token]
  );

  const _onDetail = useCallback(
    (id) => {
      navigate(ROUTES.DELIVERY_ASSOCIATE.DETAIL, {
        state: {
          id,
          prevPage: location.pathname,
        },
      });
    },
    [location.pathname, navigate]
  );

  const columns = [
    {
      title: (
        <span className="font-roboto text-lg font-[500] text-[#222222]">
          DA Type
        </span>
      ),
      dataIndex: "driver_photo",
      width: 150,
    },
    {
      title: (
        <span className="font-roboto text-lg font-[500] text-[#222222]">
          DA ID
        </span>
      ),
      dataIndex: "delivery_associate_id",
      width: 155,
    },
    {
      title: (
        <span className="font-roboto text-lg font-[500] text-[#222222]">
          Driver Name
        </span>
      ),
      dataIndex: "driver_name",
      width: 150,
    },
    {
      title: (
        <span className="font-roboto text-lg font-[500] text-[#222222]">
          Vehicle Type
        </span>
      ),
      dataIndex: "vehicle_type",
      width: 150,
    },
    {
      title: (
        <span className="font-roboto text-lg font-[500] text-[#222222]">
          Skillset
        </span>
      ),
      dataIndex: "skillset",
      width: 150,
    },
    {
      title: (
        <span className="font-roboto text-lg font-[500] text-[#222222]">
          Phone
        </span>
      ),
      dataIndex: "phone",
      width: 150,
    },
    {
      title: (
        <span className="font-roboto text-lg font-[500] text-[#222222]">
          DA Status
        </span>
      ),
      dataIndex: "da_status",
      width: 150,
    },
    {
      title: (
        <span className="font-roboto text-lg font-[500] text-[#222222]">
          Ongoing Trip
        </span>
      ),
      dataIndex: "ongoing_trip",
      width: 150,
    },
    {
      title: (
        <span className="font-roboto text-lg font-[500] text-[#222222]">
          Action
        </span>
      ),
      dataIndex: "action",
      width: 150,
      render: (action) => <span>{action}</span>,
    },
  ];

  const dataSources = listDeliveryAssociate?.map((item) => ({
    driver_photo: (
      // <div className="w-[70px] h-[70px] rounded-[50%] border-[#CF0000] border-[2px] overflow-hidden">
      //   <img
      //     src={item.driver_photo ? item.driver_photo : ProfileKosong}
      //     alt=""
      //   />
      // </div>
      <span className="font-roboto text-lg text-[#222222] font-medium">
        <img src={item.driver_type==="outsource" ? OutsourceIcon : OwnedIcon} alt="-"/>
        {/* {item.driver_type ? item.driver_type : "-"} */}
      </span>
    ),
    delivery_associate_id: (
      <span className="font-roboto text-lg text-[#222222] font-medium">
        {item.delivery_associate_id ? item.delivery_associate_id : "-"}
      </span>
    ),
    driver_name: (
      <span className="font-roboto text-lg text-[#222222] font-medium">
        {item.first_name ? `${item.first_name} ${item.last_name}` : "-"}
      </span>
    ),
    vehicle_type: (
      <span className="font-roboto text-lg text-[#222222] font-medium">
        {item.vehicle_type ? item.vehicle_type : "-"}
      </span>
    ),
    skillset: (
      <span className="font-roboto text-lg text-[#222222] font-medium">
        {item.skill_set_name[0]}
      </span>
    ),
    phone: (
      <span className="font-roboto text-lg text-[#222222] font-medium">
        {item.phone}
      </span>
    ),
    da_status: (
      <span className="font-roboto text-lg text-[#222222] font-medium">
        {/* {item.status} */}
        <img src={item.status ==="Invitation Expired" ? InvitationExpiredIcon : item.status ==="Invitation Sent" ? InvitationSentIcon : item.status === "Non-Active" ? DANonActiveIcon : item.status === "Active" ? DAActiveIcon : item.status ==="Invitation Opened" ? InvitationOpenedIcon : ""} alt="-"/>
      </span>
    ),
    ongoing_trip: (
      <span className="font-roboto text-lg text-[#222222] font-medium">
        {item.trip_name ? item.trip_name : "-"}
      </span>
    ),
    action: (
      <div className="flex gap-[26px]">
        <Tooltip
          title={
            item?.driver_type === "owned"
              ? "Can't be edit!"
              : t("VEHICLE_LIST:EDIT_TOOLTIP")
          }
          color="#CF0000"
        >
          <button disabled={item?.driver_type === "owned" ? true : false}>
            <img
              className={item?.driver_type === "owned" ? "opacity-30" : ""}
              src={EditIcon}
              onClick={
                item?.driver_type === "owned"
                  ? undefined
                  : () => _toEdit(item.delivery_associate_id)
              }
              alt="icon-edit"
            />
          </button>
        </Tooltip>
        <Tooltip
          title={
            item?.trip_name
              ? "Can't be delete!"
              : t("VEHICLE_LIST:DELETE_TOOLTIP")
          }
          color="#CF0000"
        >
          <button disabled={item?.trip_name ? true : false}>
            <img
              className={item?.trip_name ? "opacity-30" : ""}
              src={DeleteIcon}
              alt="icon-delete"
              onClick={
                item?.trip_name
                  ? undefined
                  : () =>
                      _actionDelete(
                        item.delivery_associate_id,
                        item.updated_at,
                        item.vehicle_type,
                        item.first_name
                          ? `${item.first_name} ${item.last_name}`
                          : "-"
                      )
              }
            />
          </button>
        </Tooltip>
        <Tooltip title={t("VEHICLE_LIST:DETAIL_TOOLTIP")} color="#CF0000">
          <button>
            <img
              src={DetailIcon}
              alt="icon-detail"
              onClick={() => _onDetail(item.delivery_associate_id)}
            />
          </button>
        </Tooltip>
      </div>
    ),
  }));

  return (
    <div>
      <Breadcumbs
        jmlLevel={3}
        menuLevel1="Master"
        menuLevel2="Fleet"
        menuLevel3="Delivery Associate"
      />
      <TitlePage title="Delivery Asscoiate" />
      <div className="flex justify-between items-center w-full h-[47px]">
        <div className="flex gap-4">
          <AutoComplete
            allowClear
            options={searchRecommendation}
            onSelect={onSelectedData}
          >
            <Input
              placeholder="Search Username or Name"
              size="large"
              onChange={(evt) => onChangeSearch(evt.target.value)}
            />
          </AutoComplete>
          <DropdownSearchDepot className=" w-[300px]" setValueDDS={setDepot} />
        </div>
        <ButtonAddWithIcon
          className="h-[40px]"
          buttonName="Add Delivery Associate"
          onClick={_toAdd}
        />
      </div>
      <div className="mt-10">
        {isSkeleton ? (
          <Skeleton />
        ) : (
          <div className={style.tableContainer}>
            <CustomTable
              currentPage={params?.page}
              columns={columns}
              data={dataSources}
              pageLimit={params?.limit}
              onChange={(page, pageSize) => handleChangeLimit(page, pageSize)}
              total={initiateDeliveryAssociate?.count_data}
              defaultCurrent={1}
              showPagination
            />
          </div>
        )}
      </div>
      <DeleteConfirmationModal
        isOpen={deleteConfirmationModalOpen}
        onOk={() => setDeleteConfirmationModalOpen(false)}
        onCancel={() => doDeleteDA(selectedId, selectedUpdatedAt)}
        closable={false}
        width={440}
        className={style.modalContainer}
        okText="Cancel"
        cancelText="Yes, Delete"
        title="Delete Data?"
        description={
          <p>
            Are you sure want to delete <br />{" "}
            <strong>
              {selectedDriverName} - {selectedVehicleType}?
            </strong>
          </p>
        }
      />

      <SuccessModal
        isOpen={successModalOpen}
        onOk={()=>setSuccessModalOpen(false)}
        closable={false}
        width={280}
        className={style.deleteModal}
        okText="Ok"
        title="Well Done"
        description="Your data has been deleted"
      />
      <ModalFailedDelete
        show={failedModalOpen}
        action={() => setFailedModalOpen(false)}
        closable={false}
        width={414}
        className={style.deleteModal}
        okText="Ok"
        title="Data Cant be added"
        description={failedMessage}
      />
    </div>
  );
};

export default DeliveryAssociateList;
